import { store } from '../store';

const attachDynamicReducers = reducers => store.attachReducers(reducers);

export default attachDynamicReducers;
